module.exports = __webpack_public_path__ + "img/img1.606da127.png";